<template>
    <button class="swap-item-button" :class="classes" @click.stop="$emit('click')">
        <span class="swap-item-icon-container">
            <svg class="swap-item-icon" :class="`swap-item-icon--${this.icon}`" :style="{ height: iconSize }" xmlns="http://www.w3.org/2000/svg" viewBox="-869.182 2717.125 14.364 19.75">
                <path id="Path_271" data-name="Path 271" d="M7.182,4.489V7.182l3.591-3.591L7.182,0V2.693A7.2,7.2,0,0,0,0,9.875a8.025,8.025,0,0,0,1.077,3.86l1.347-1.347A4.76,4.76,0,0,1,1.8,9.875,5.4,5.4,0,0,1,7.182,4.489Zm6.1,1.526L11.94,7.361a5.78,5.78,0,0,1,.628,2.514,5.4,5.4,0,0,1-5.386,5.386V12.568L3.591,16.159,7.182,19.75V17.057a7.2,7.2,0,0,0,7.182-7.182A8.025,8.025,0,0,0,13.286,6.015Z" transform="translate(-869.182 2717.125)"/>
            </svg>
        </span>
        <span class="swap-item-text" v-show="!!text">{{ text }}</span>
    </button>
</template>

<script>
    import Mixins from '../../mixins/mixins.js';

    export default {
        props: {
            classes: String|Array|Object,
            text: String,
            icon: String,
            iconSize: String,
        },
        mixins: [Mixins],
    }
</script>

<style lang="scss" scoped>
    .swap-item-button {
        .swap-item-icon {
            height: 19px;
            vertical-align: middle;
            fill: #B0B0B0;
            &--white {
                fill: #FFFFFF;
            }
        }

        .swap-item-text {
            margin-left: 6px;
        }
    }
</style>